module.exports = __webpack_public_path__ + "static/media/advertisement.1812b496.svg";